import HeaderPortal from "components/portal/header-portal";
import { List, Icon } from "components";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
    DropdownMenuSeparator,
} from "ui/components/dropdown-menu";
import { Button } from "ui/components/button";
import React from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { eventBus } from "utils/eventBus";
import CreateOutcomeDialog from "./form/input";
import { MENU } from "icons";
import { useRemoveOutcome } from "./delete/mutation";

export default function Outcomes() {
    const { casestudyId } = useParams();
    const { itemId } = useParams();
    const navigate = useNavigate();
    const dialogOpen = typeof itemId !== "undefined";
    const editingId = itemId || "+";

    const removeOutcome = useRemoveOutcome({
        onSuccess: () => {
            eventBus.emit("refresh:list", `outcomesoutcomes${casestudyId}`);
        },
    });
    const fields = [
        "id",
        "type",
        "description",
        "case_study.id",
    ];
    const columns = [
        {
            id: "type",
            header: "Type",
            accessorKey: "type",
            cell: ({ row }) => {
                return <span className="capitalize">{row.original?.type?.replace(/_/g, ' ')}</span>;
            }
        },
        {
            id: "description",
            header: "Description",
            accessorKey: "description",
        },
        {
            id: "actions",
            header: "",
            accessorKey: "employee.id",
            cell: ({ row }) => {
                const id = row.original.id;
                return (
                    <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button size="icon" variant="outline">
                                    <Icon icon={MENU} className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <DropdownMenuItem
                                    onClick={() => {
                                        // open edit dialog via url param
                                        navigate(id);
                                    }}
                                    className="cursor-pointer"
                                >
                                    Edit
                                </DropdownMenuItem>
                                <DropdownMenuSeparator />
                                <DropdownMenuItem
                                    onClick={() => removeOutcome.mutateAsync({ id })}
                                    disabled={removeOutcome.isPending}
                                    className="cursor-pointer"
                                >
                                    Delete
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                );
            },
            sortable: false,
            meta: { align: "right" },
        },
    ];

    const defaultFilters = {
        case_study: {
            id: {
                _eq: casestudyId,
            }
        },
    };


    const handleCreate = () => {
        // open create dialog via URL: navigate to '+' under current path
        navigate("+");
    };

    const handleDialogOpenChange = (open) => {
        if (!open) {
            // close dialog by navigating back to base outcomes route
            navigate("..");
        }
    };

    return (
        <div className="flex-1">
            <HeaderPortal>
                <Button onClick={handleCreate}>
                    Add
                </Button>
            </HeaderPortal>
            <List
                title="Outcomes"
                storageKey={`outcomes${casestudyId}`}
                endPoint="outcomes"
                filters={defaultFilters}
                columns={columns}
                meta={{ fields }}
                hidePagination={true}
                showSearch={false}
                perPage={10}
                sortBy="date_created"
            />
            <CreateOutcomeDialog
                open={dialogOpen}
                onOpenChange={handleDialogOpenChange}
                itemId={editingId}
            />
        </div>
    );
}
